<ion-content class="ion-padding">
  <div class="container">
    <ion-icon name="sync-circle-outline" class="icon"></ion-icon>

    <h2>Registration Pending</h2>

    <p>
      Your registration has been saved.<br /><br />
      We’ll complete your registration automatically as soon as you’re back online.<br /><br />
      You don’t need to do anything—just reconnect to the internet and we’ll take care of the rest.
    </p>
  </div>
</ion-content>
